import {
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Heading,
  HStack,
  Input,
  Stack,
  useToast,
  VStack,
} from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import * as yup from 'yup';
import {
  getUserDetails,
  updateUserDetail,
} from '../../stores/slices/user/userActions';
import { getCurrentUserInfo } from '../../utils/getCurrentUserInfo';
import Card from '../Card';

const AccountDetails = () => {
  const { userInfo, assumedUserInfo, isAssumed } = useSelector(
    state => state.user
  );
  const currentUser = getCurrentUserInfo({
    assumedUserInfo,
    isAssumed,
    userInfo,
  });
  const dispatch = useDispatch();
  const toast = useToast();

  const schema = yup
    .object({
      first_name: yup.string().required('First name is required'),
      last_name: yup.string().required('Last name is required'),
      company_role: yup.string().required('Company role is required'),
    })
    .required();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const onSave = async data => {
    const res = await dispatch(updateUserDetail(data));
    if (res.type === 'user/updateUserDetail/rejected') {
      toast({
        title: 'Something went wrong',
        description: 'Please try again later.',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
      });
    } else {
      dispatch(getUserDetails());
      toast({
        description: 'Account details updated',
        colorScheme: 'primary',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'bottom-right',
        variant: 'primary',
      });
    }
  };
  return (
    <Card mx={'auto'} h={'full'} px={{ base: 4, md: 10 }}>
      <form onSubmit={handleSubmit(onSave)}>
        <VStack alignItems={'start'} spacing={'8'}>
          <VStack w={'full'} alignItems={'start'}>
            <HStack
              alignItems={'center'}
              justifyContent={'space-between'}
              spacing={'10'}
              w={'full'}
            >
              <Heading as="h4" size="md">
                Account Details
              </Heading>

              <Button type="submit" isLoading={isSubmitting}>
                Save
              </Button>
            </HStack>
            <Stack w={'full'} direction={{ base: 'column', lg: 'row' }}>
              <FormControl id="first_name" isInvalid={errors.first_name}>
                <FormLabel>First Name</FormLabel>
                <Input
                  id="first_name"
                  {...register('first_name')}
                  defaultValue={currentUser.first_name || ''}
                />
                <FormErrorMessage>
                  {errors.first_name && errors.first_name.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="last_name" isInvalid={errors.last_name}>
                <FormLabel>Last Name</FormLabel>
                <Input
                  id="last_name"
                  {...register('last_name')}
                  defaultValue={currentUser.last_name || ''}
                />
                <FormErrorMessage>
                  {errors.last_name && errors.last_name.message}
                </FormErrorMessage>
              </FormControl>
              <FormControl id="company_role" isInvalid={errors.company_role}>
                <FormLabel>Company Role</FormLabel>
                <Input
                  id="company_role"
                  {...register('company_role')}
                  defaultValue={currentUser.company_role || ''}
                />
                <FormErrorMessage>
                  {errors.company_role && errors.company_role.message}
                </FormErrorMessage>
              </FormControl>
            </Stack>
            <Checkbox
              defaultChecked={currentUser.notification_subscription}
              {...register('notification_subscription')}
            >
              Weekly Notification Email
            </Checkbox>
          </VStack>
        </VStack>
      </form>
    </Card>
  );
};

export default AccountDetails;
